import Rectangle from "./Rectangle";
import RightAngledTriangle from "./RightAngledTriangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import SlopedRightRectangle from "./SlopedRightRectangle";

export default class AbstractSlopedRightRectangle extends AbstractShape {
	constructor( height, width_top, width_bottom ) {
		super();

		this.height = height;
		this.width_top = width_top;
		this.width_bottom = width_bottom;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.height, this.get_longest_width() );
	}

	get_area() {
		const largest_height = this.get_longest_width();
		const smallest_height = this.get_shortest_width();
		const base_rectangle = new Rectangle( this.height, this.get_shortest_width() );
		const top_triangle = new RightAngledTriangle( this.height, largest_height.subtract( smallest_height ) );
		return base_rectangle.get_area().add( top_triangle.get_area() );
	}

	get_circumference() //Pythagorean theorem, a^2 + b^2 = c^2
	{
		const diagonal_length = Math.sqrt( Math.pow( this.height.in_mm(), 2 ) + Math.pow( this.get_longest_width().subtract( this.get_shortest_width() ).in_mm(), 2 ) );
		return this.height.add( this.width_top ).add( this.width_bottom ).add( new Length( diagonal_length ) );
	}

	get_longest_width() {
		return this.width_top.max( this.width_bottom );
	}

	get_shortest_width() {
		return this.width_top.min( this.width_bottom );
	}

	get_height() {
		return this.height;
	}

	get_width_top() {
		return this.width_top;
	}

	get_width_bottom() {
		return this.width_bottom;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			height: maximum_rectangle.get_height(),
			width_top: maximum_rectangle.get_longest_side(),
			width_bottom: maximum_rectangle.get_longest_side()
		};
	}

	get_dimension_keys() {
		return ["width_top", "height", "width_bottom"];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			height: this.height.in_mm(),
			width_top: this.width_top.in_mm(),
			width_bottom: this.width_bottom.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new SlopedRightRectangle( new Length( primitives.height ), new Length( primitives.width_top ), new Length( primitives.width_bottom ) );
	}

}
